// @ts-nocheck

import Button from 'atoms/button/button';
import DeleteModal from 'components/DeleteModal';
import { handleRowDelete } from 'models/dynamicGrid/sagaActions';
import { getGridMetadata, getTableSelection } from 'models/dynamicGrid/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import React from 'react';
import { getDispatch, getState } from 'reducers';
const DefaultActionHandler = (props) => {
	let row = props.data;
	const dispatch = getDispatch();

	const [showModal, setShowModal] = React.useState(false);
	const handleDelete = () => {
		const metaData = getGridMetadata(getState(), props.row.AppTableID);
		const selectedRowKeys: any = getTableSelection(getState(), props.row.AppTableID.toString());
		if (props.row.AppTableID === 29) {
			dispatch(
				handleRowDelete({
					rowIdentifier: [row[metaData.selectRowKey]],
					isParent: true,
					tableId: props.row.AppTableID,
				})
			);
		} else {
			dispatch(
				handleRowDelete({
					tableId: props.row.AppTableID,
					rowIdentifier: row[metaData.selectRowKey],
					deletedRows: [row],
					isUploadGrid: props?.gridConfig?.isUploadGrid,
					deleteActionFieldGroups: metaData?.dataProviderOptions?.body?.deleteActionFieldGroups,
					// isSelectAll: selectedRowKeys?.isSelectAll,
					// selectAllSearch: JSON.stringify({
					// 	filter: createFiltersFromQueries(selectedRowKeys?.search)
					// })
				})
			);
		}
	};
	if (props.node.leafGroup) {
		return null;
	}
	return (
		<>
			<Stack gutter="medium" align="center" position="center">
				<StackItem className="tbl-action-buttons">
					<Button
						disabled={row?.IsReadOnly}
						handleClick={() => setShowModal(true)}
						isActive={row?.IsReadOnly ? false : true}
					>
						<i className="icon-trash" />
					</Button>
				</StackItem>
			</Stack>
			{showModal && <DeleteModal success={() => handleDelete()} hideModal={() => setShowModal(false)} />}
		</>
	);
};

function GridActionHandler(props) {
	let Component = props?.customActions?.component ?? DefaultActionHandler;

	return (
		<>
			{/* Render the cell value here */}
			{Component && <Component {...props} row={props.data}></Component>}
		</>
	);
}

export default GridActionHandler;
